import React from "react";
import { TreeSelect } from "antd";
import type { TreeSelectProps } from "antd/es/tree-select";
import "./TreeSelectWithTags.scss";

export interface TreeSelectWithTagsProps
  extends Omit<TreeSelectProps, "value" | "onChange"> {
  value?: string[];
  onChange?: (value: string[]) => void;
  treeData: any[];
  tagColor?: string;
}

interface TreeNode {
  label?: string;
  value?: string;
  title?: string;
  children?: TreeNode[];
}

const findLabelInTreeData = (
  value: string,
  treeData: TreeNode[]
): string | null => {
  for (const node of treeData) {
    if (node.value === value) {
      return node.label || node.title || value;
    }

    if (node.children && node.children.length > 0) {
      const found = findLabelInTreeData(value, node.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

const TreeSelectWithTags: React.FC<TreeSelectWithTagsProps> = ({
  value = [],
  onChange,
  treeData,
  tagColor = "#ff9f1c",
  loading,
  placeholder = "Please select",
  treeCheckable = true,
  showCheckedStrategy = TreeSelect.SHOW_PARENT,
  ...props
}) => {
  const handleRemove = (removedValue: string) => {
    const newValue = value.filter((v) => v !== removedValue);
    onChange?.(newValue);
  };

  return (
    <div className="tree-select-with-tags">
      <TreeSelect
        value={value}
        onChange={onChange}
        treeData={treeData}
        loading={loading}
        placeholder={placeholder}
        treeCheckable={treeCheckable}
        showCheckedStrategy={showCheckedStrategy}
        maxTagCount={0}
        className="tree-select-container"
        rootClassName="tree-select-root-container"
        tagRender={() => (
          <span className="tree-select-tag-fake-placeholder">
            {placeholder}
          </span>
        )}
        {...props}
      />
      {value.length > 0 && (
        <div className="tree-select-tags-container">
          {value.map((selectedValue) => {
            const label = findLabelInTreeData(selectedValue, treeData);
            if (!label) return null;

            return (
              <span
                key={selectedValue}
                className="tree-select-tag"
                style={{ background: tagColor }}
              >
                {label}
                <button
                  onClick={() => handleRemove(selectedValue)}
                  className="tree-select-tag-remove-btn"
                  title={`Remove ${label}`}
                >
                  x
                </button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TreeSelectWithTags;
